var translations = {
    de: {
        title: 'Bei smava brauchen Sie sich keine Sorgen bezüglich der SCHUFA zu machen.',
        content: 'Beim Vergleich von Bau-/Immobilienfinanzierungen wird die SCHUFA nicht von smava angefragt.',
        modalTitle: 'Beim Vergleich von Bau-/Immobilienfinanzierungen wird die SCHUFA nicht von smava angefragt.',
        modalContent: 'Wir erstellen für Sie auf Basis Ihrer eingegebenen Daten ein individuelles Finanzierungsangebot einer unserer über 450 regionalen und überregionalen Bankpartner. Dieses Angebot ist kostenlos und unverbindlich. Es erfolgt keine Konditionenanfrage bei der SCHUFA durch smava. Erst wenn Sie sich für den Abschluss eines bestimmten Kredites entschieden haben, wird der ausgewählte Bankpartner eine Anfrage bei der SCHUFA stellen.',
    },
};
export default translations;
